import $ from "jquery";

//https://boards-api.greenhouse.io/v1/boards/rocksteadymusicschool/departments

export default class Vacancies {
  $el = $("section.vacancies");
  apiURL =
    "https://boards-api.greenhouse.io/v1/boards/rocksteadymusicschool/departments";
  departments = null;
  vacancies = null;
  template = null;
  offset = 0;
  totalJobs = 0;

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.getTemplate();
    this.getDepartments();
    this.getVacancies();
    this.onShowMoreClick();
  }

  getTemplate() {
    this.template = this.$el.find(".job-card-template").clone();
  }

  getDepartments() {
    const depString = this.$el.find(".departments").text();

    if (!depString) return;

    this.departments = depString.split(",").map((item) => item.trim());

    return this.departments;
  }

  getVacancies() {
    $.ajax({
      url: this.apiURL,
    }).done((data) => {
      // Get the jobs in a department only if it is in the departments array
      if (this.departments) {
        this.vacancies = data.departments.filter((department) =>
          this.departments.includes(department.name)
        );
      } else {
        this.vacancies = data.departments;
      }

      this.printVacancies(5, this.offset);
    });
  }

  printVacancies(amount = 5, offset = 0) {
    let jobs = [];
    // Add vacancies to jobs array limiting the amount of vacancies to show and an offset.
    this.vacancies.forEach((department, index) => {
      department.jobs.forEach((job) => {
        jobs.push({
          title: job.title,
          url: job.absolute_url,
          department: department.name,
          location: job.location.name,
          updated_at: job.updated_at,
        });
      });
    });

    this.totalJobs = jobs.length;

    // Get the jobs after the offset.
    jobs = jobs.slice(offset, offset + amount);

    // Limit the amount of jobs to show.
    jobs = jobs.slice(0, amount);

    jobs.forEach((job, index) => {
      const $jobCard = this.template.clone();

      $jobCard.find(".job-title").text(job.title);
      $jobCard.find(".job-url").attr("href", job.url);

      this.$el.find(".vacancies-list").append($jobCard);
    });

    this.offset += amount;
  }

  onShowMoreClick() {
    this.$el.find(".show-more").on("click", () => {
      this.printVacancies(1000, this.offset);

      this.offset += 5;

      this.$el.find(".show-more").hide();
    });
  }
}
